import React, { useState } from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { IconButton, Tooltip as MuiTooltip, Dialog, DialogTitle, DialogContent, DialogActions, Button, Box } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend, ChartDataLabels);

const allLabels = ['Servicios logísticos', 'Retail', 'Automotriz', 'Alimentos', 'Construcción', 'Manufactura', 'Salud/Farmacéutica'];

const rotacionInventarioData2023 = {
  'Servicios logísticos': 4.0,
  'Retail': 5.2,
  'Automotriz': 6.0,
  'Alimentos': 6.1,
  'Construcción': 6.4,
  'Manufactura': 6.8,
  'Salud/Farmacéutica': 8.0,
};

const rotacionInventarioData2024 = {
  'Servicios logísticos': 4.4,
  'Retail': 10.5,
  'Automotriz': 2.7,
  'Alimentos': 8.5,
  'Construcción': 12.3,
  'Manufactura': 2.7,
  
};

const colorMap = {
  2023: '#1F3D58',
  2024: '#476A8E',
};

const RotacionInventarioBar = () => {
  const [infoOpen, setInfoOpen] = useState(false);

  const labels = allLabels;
  const dataValues2023 = labels.map(label => rotacionInventarioData2023[label]);
  const dataValues2024 = labels.map(label => rotacionInventarioData2024[label]);

  const chartData = {
    labels: labels,
    datasets: [
      {
        label: 'Rotación Anual (2022)',
        data: dataValues2023,
        backgroundColor: colorMap[2023],
        borderColor: '#fff',
        borderWidth: 1,
        barThickness: 25,
      },
      {
        label: 'Rotación Anual (2023)',
        data: dataValues2024,
        backgroundColor: colorMap[2024],
        borderColor: '#fff',
        borderWidth: 1,
        barThickness: 25,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        top: 20,
        bottom: 40, // Aumentar padding inferior
        left: 10,
        right: 10,
      },
    },
    indexAxis: 'y',
    plugins: {
      legend: {
        position: 'top',
      },
      tooltip: {
        callbacks: {
          label: (context) => `${context.dataset.label}: ${context.raw}`,
        },
      },
      datalabels: {
        color: '#1A1A1A',
        font: {
          weight: 'bold',
          size: 14,
        },
        formatter: (value) => (value), // Formato como porcentaje
        anchor: 'end',
        align: 'end',
        offset: 5,
      },
    },
    scales: {
      x: {
        beginAtZero: true,
        max: 14,
        ticks: {
          stepSize: 1,
          font: {
            size: 12,
          },
        },
        title: {
          display: true,
          text: 'Rotación Anual',
          font: {
            size: 12,
            weight: '',
          },
        },
      },
      y: {
        ticks: {
          font: {
            size: 12,
          },
        },
      },
    },
  };

  const infoContent = {
    Analisis: 'En 2023, Retail y Construcción lideran en rotación de inventario, reflejando una mayor agilidad en sus operaciones. Alimentos y Manufactura mantienen un ritmo sólido, mientras que Servicios logísticos presenta la menor rotación, sugiriendo una gestión más conservadora de su stock.',
    formula: 'Rotación de Inventario = Costo de los bienes vendidos / Promedio de inventario',
    description: 'Esta gráfica muestra la frecuencia con la que se renueva el inventario en distintos sectores industriales durante los años 2022 y 2023. La rotación de inventario es un indicador clave de la eficiencia en la gestión de inventarios.',
  };
  

  return (
    <div style={{ maxWidth: '800px', height: '555px', margin: '0 auto' }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <MuiTooltip title="Información de la gráfica">
          <IconButton onClick={() => setInfoOpen(true)}>
            <InfoIcon />
          </IconButton>
        </MuiTooltip>
      </Box>
      <Bar data={chartData} options={options} />
      <Dialog open={infoOpen} onClose={() => setInfoOpen(false)}>
        <DialogTitle>Información de la Gráfica</DialogTitle>
        <DialogContent>
        <p><strong>Análisis:</strong> {infoContent.Analisis}</p>
          <p><strong>Fórmula:</strong> {infoContent.formula}</p>
          <p><strong>Descripción:</strong> {infoContent.description}</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setInfoOpen(false)} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
  
};

export default RotacionInventarioBar;
